<form [formGroup]="transitionReportForm" (ngSubmit)="onSubmit()" class="transition-wrapper" *transloco="let t">
  <!-- Title -->
  <div class="title-wrapper">
    <h1>{{ t('transition/report/transitionReport') }}</h1>
    <p>{{ t('transition/report/results') }}</p>
  </div>

  <!-- Sections -->
  <div class="sections-wrapper" *ngIf="child$ | async as child">
    <!-- Child info -->
    <details open>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            img:
              (child$ | async)?.gender === 'male'
                ? '../../../../../assets/img/iconsDefault/boy.svg'
                : '../../../../../assets/img/iconsDefault/girl.svg',
            text: child.name + ' ' + child.surname
          }
        "
      ></ng-container>
      <div class="details-content">
        <!-- Date -->
        <div class="fields-wrapper">
          <div class="form-group">
            <label for="dateOfBirth">{{ t('child/dateOfBirth') }} <span class="required">*</span></label>
            <div class="input-group date-input">
              <input
                id="dateOfBirth"
                class="form-control form-control-lg"
                [placeholder]="t('child/selectDate')"
                name="dp"
                ngbDatepicker
                #dp="ngbDatepicker"
                required
                [minDate]="{ year: 1900, month: 1, day: 1 }"
                [maxDate]="{ year: 2100, month: 1, day: 1 }"
                formControlName="birth_date"
              />
              <div class="input-group-append">
                <button class="btn" (click)="dp.toggle()" type="button">
                  <img src="assets/img/calendar.svg" alt="calendar" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Street and number, village -->
        <div class="fields-wrapper">
          <div class="form-group">
            <label for="streetAndNumber"
              >{{ t('transition/report/streetAndNumber') }} <span class="grey">({{ t('transition/report/permanentResidence') }})</span>
              <span class="required">*</span></label
            >
            <input id="streetAndNumber" class="form-control" formControlName="street_and_house_number" />
          </div>
          <div class="form-group">
            <label for="village"
              >{{ t('transition/report/village') }} <span class="grey">({{ t('transition/report/permanentResidence') }})</span>
              <span class="required">*</span></label
            >
            <input id="village" class="form-control" formControlName="city" />
          </div>
        </div>
        <!-- PSC -->
        <div class="fields-wrapper">
          <div class="form-group">
            <label for="psc">{{ t('transition/report/psc') }} <span class="required">*</span></label>
            <input id="psc" class="form-control" formControlName="postal_code" />
          </div>
        </div>
      </div>
    </details>

    <!-- Section 1 - interests -->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            sectionIndex: 1,
            text: t('transition/report/sections/interests')
          }
        "
      ></ng-container>
      <div class="details-content">
        <div class="form-group">
          <div class="text-area-wrapper">
            <textarea class="form-control" maxlength="500" rows="7" formControlName="interests"></textarea>
            <span class="remaining">{{ 500 - transitionReportForm.controls.interests.value.length }}</span>
          </div>
          <span class="form-group-hint">{{ t('transition/report/sections/interests/hint') }}</span>
        </div>
      </div>
    </details>
    <!-- Section - Comp learning -->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            text: t('transition/report/sections/compLearning')
          }
        "
      ></ng-container>
      <div class="details-content">
        <!-- 1. K učení -->
        <ng-container *ngFor="let compSection of compLearningSection; trackBy: trackById; let index = index">
          <div class="choose-wrapper">
            <span class="choose-title">{{ compSection.title }}</span>
            <div class="form-group checkbox-wrapper" *ngFor="let control of compSection.controls; trackBy: trackById">
              <label class="checkbox-container"
                ><input type="checkbox" [formControlName]="control.formControlName" /><span class="checkmark"></span
              ></label>
              <span class="checkbox-label">{{ control.label }}</span>
            </div>
          </div>

          <div *ngIf="index !== compLearningSection.length - 1" class="spacer"></div>
        </ng-container>
      </div>
    </details>
    <!-- Section 2 - Methods-->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            sectionIndex: 2,
            text: t('transition/report/sections/methods')
          }
        "
      ></ng-container>
      <div class="details-content">
        <div class="form-group">
          <div class="text-area-wrapper">
            <textarea class="form-control" maxlength="350" rows="5" formControlName="method_text"></textarea>
            <span class="remaining">{{ 350 - transitionReportForm.controls.method_text.value.length }}</span>
          </div>
        </div>
        <div class="fields-wrapper">
          <!-- Výukové metody -->
          <div class="choose-wrapper" *ngFor="let section of methodsSection; trackBy: trackById">
            <span class="choose-title" [innerHTML]="section.title"></span>
            <div class="form-group checkbox-wrapper" *ngFor="let sectionControls of section.controls; trackBy: trackById">
              <label class="checkbox-container"
                ><input type="checkbox" [formControlName]="sectionControls.formControlName" /><span class="checkmark"></span
              ></label>
              <span class="checkbox-label">{{ sectionControls.label }}</span>
              <i *ngIf="sectionControls.tooltip" class="material-symbols-rounded" [ngbTooltip]="sectionControls.tooltip">info</i>
            </div>
          </div>
        </div>
      </div>
    </details>

    <!-- Section 3 - Family cooperation -->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            sectionIndex: 3,
            text: t('transition/report/sections/cooperation')
          }
        "
      ></ng-container>
      <div class="details-content">
        <div class="form-group">
          <div class="text-area-wrapper">
            <textarea class="form-control" maxlength="350" rows="5" formControlName="family_cooperation"></textarea>
            <span class="remaining">{{ 350 - transitionReportForm.controls.family_cooperation.value.length }}</span>
          </div>
        </div>
      </div>
    </details>
    <!-- Section 4 - Support -->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            sectionIndex: 4,
            text: t('transition/report/sections/support')
          }
        "
      ></ng-container>
      <div class="details-content">
        <div class="choose-wrapper">
          <div class="area-wrapper" *ngFor="let section of supportSection; trackBy: trackById">
            <div class="area-heading">
              <span class="area-heading-title">{{ t('transition/report/sections/support/' + section.key) }}</span>
              <div class="form-checkbox-wrapper">
                <span>
                  <ng-container *ngIf="transitionReportForm.controls[section.key + '_support_needed']?.value === false">{{
                    t('transition/report/no')
                  }}</ng-container>
                  <ng-container *ngIf="transitionReportForm.controls[section.key + '_support_needed']?.value === true">{{
                    t('transition/report/yes')
                  }}</ng-container>
                </span>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" [formControlName]="section.key + '_support_needed'" />
                </div>
              </div>
              <div
                class="form-group class-select"
                *ngIf="section.hasLevel && transitionReportForm.controls[section.key + '_diagnostic_date']?.value"
              >
                <ng-select
                  [items]="competenceLevels"
                  [multiple]="false"
                  bindLabel="title"
                  bindValue="value"
                  [placeholder]="t('transition/report/competenceLevel/placeholder')"
                  [formControlName]="section.key + '_level'"
                >
                </ng-select>
              </div>
            </div>

            <!-- Note -->
            <div class="form-group">
              <div class="text-area-wrapper">
                <textarea
                  class="form-control"
                  maxlength="65"
                  rows="1"
                  [formControlName]="section.key + '_notes'"
                  [placeholder]="t('transition/report/note')"
                ></textarea>
                <span class="remaining">{{ 65 - transitionReportForm.controls[section.key + '_notes']?.value.length }}</span>
              </div>
            </div>

            <!-- Date -->
            <span *ngIf="transitionReportForm.controls[section.key + '_diagnostic_date']?.value" class="diagnostic-date"
              >{{ t('transition/report/sections/support/dragnosticsDate') }}:
              {{ transitionReportForm.controls[section.key + '_diagnostic_date']?.value | date }}</span
            >
          </div>
        </div>
      </div>
    </details>

    <!-- Section 5 - Support measurement -->
    <details>
      <ng-container
        *ngTemplateOutlet="
          detailSummary;
          context: {
            sectionIndex: 5,
            text: t('transition/report/sections/measurement')
          }
        "
      ></ng-container>
      <div class="details-content">
        <div class="form-checkbox-wrapper">
          <span>
            <ng-container *ngIf="transitionReportForm.controls.support_measures_recommended.value === false">{{
              t('transition/report/no')
            }}</ng-container>
            <ng-container *ngIf="transitionReportForm.controls.support_measures_recommended.value === true">{{
              t('transition/report/yes')
            }}</ng-container>
          </span>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" formControlName="support_measures_recommended" />
          </div>
        </div>
      </div>
    </details>
  </div>

  <!-- Submit button -->
  <div class="btn-wrapper">
    <button class="btn btn-secondary" type="submit" [disabled]="transitionReportForm.invalid" [attr.loading]="loading$ | async">
      {{ t('transition/report/save') }}
    </button>
    <span class="disabled-msg">{{ t('shared/formFieldsMissing') }}</span>
  </div>
</form>

<button class="x-button" (click)="goBack()"><i class="material-symbols-rounded">close</i></button>

<!-- Summary template -->
<ng-template #detailSummary let-img="img" let-text="text" let-sectionIndex="sectionIndex">
  <summary>
    <img *ngIf="img" [src]="img" class="logo" />
    <div *ngIf="!img" class="section-index">{{ sectionIndex }}</div>
    <span [innerHTML]="text"></span>
    <i class="material-symbols-rounded"> arrow_drop_down </i>
  </summary>
</ng-template>
